// Library Methods
import { useTranslation } from "react-i18next";
import { useCallback } from "react";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import DefaultCard from "src/components/shared/layouts/DefaultCard/DefaultCard";

// Styles
import { getFeatureRowLabelColor } from "src/styles/mui/muiStylesHelper";

const Features = () => {
  const { t } = useTranslation("operating-manual");
  const theme = useTheme();
  const rowLabelColor = getFeatureRowLabelColor(theme);

  const tableContent = [
    {
      title: t("Tutorial"),
      content: t("Guided tutorial in patient language (Optional)"),
    },
    {
      title: t("VR mode"),
      content: t(
        "Live stream of what the patient sees in virtual reality during the exam"
      ),
    },
    {
      title: t("Encouragement"),
      content: t(
        "Audio encouragement for the patient at 30%, 50%, and 75% into the examination (Optional)"
      ),
    },
  ];

  const getTableRow = useCallback(
    (title: string, content: string) => (
      <Grid container key={title}>
        <Grid
          item
          xs={6}
          sm={3}
          sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
        >
          <Typography color={rowLabelColor} fontSize="14px" fontWeight={600}>
            {t(title)}
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          sm={9}
          sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
        >
          <Typography fontSize="14px">{t(content)}</Typography>
        </Grid>
      </Grid>
    ),
    [t, rowLabelColor]
  );

  return (
    <DefaultCard>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <Grid container>
          <Grid
            item
            xs={6}
            sm={3}
            sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <Typography fontWeight={600}>{t("Features")}</Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sm={9}
            sx={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <Typography fontWeight={600}>{t("Description")}</Typography>
          </Grid>
        </Grid>

        {tableContent.map((tableItem) =>
          getTableRow(tableItem.title, tableItem.content)
        )}
      </Box>
    </DefaultCard>
  );
};

export default Features;
